import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { Router } from '@angular/router';

// Importaciones de servicios.
import { AuthService } from '../services/auth.service';

/**
 * Guard de ruta que verifica si el usuario ya está autenticado.
 *
 * Este guard se utiliza para proteger las rutas que requieren que el usuario
 * no esté autenticado (por ejemplo, la página de inicio de sesión).
 * Comprueba si el usuario está autenticado a través del servicio de
 * autenticación. Si el usuario está autenticado, se redirige a la
 * página de activación y se bloquea el acceso a la ruta solicitada.
 * Si el usuario no está autenticado, se cierra la sesión y se permite
 * el acceso a la ruta.
 *
 * @returns Devuelve false si el usuario ya está autenticado
 * y redirige a la página de activación. Devuelve true si el usuario
 * no está autenticado, permitiendo el acceso a la ruta.
 */
export const loginGuard: CanActivateFn = (): boolean => {
  const authService = inject(AuthService);
  
  if (authService.isValidToken(authService.getToken())) {
    const router = inject(Router);

    router.navigateByUrl('/products');
    
    return false;
  }

  authService.removeToken();
  return true;
};
